/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Assignee/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TasksAssignee from 'DesignSystem/TasksAssignee/index'



/** @type {import('Simple/types.js').View} */
export default function Assignee({
  children,
  viewPath = "/DesignSystem/AutomationTask/Assignee",
  onChange
  
}) {
let eventActionAssigneeValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'assignee',
})
let eventActionAssigneeChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'assignee',
})
  return (<React.Fragment
>
<TasksAssignee
  viewPath={`${viewPath}/TasksAssignee`}
 data="event_action.assignee"
 assignee_id={eventActionAssigneeValueData}
 onChange={eventActionAssigneeChangeData}
/>
{children}
</React.Fragment>)
}